import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { AuthActions } from '../../../components/auth/auth.actions';
import { ProfileQuestionnaireActions } from './questionnaire.actions';

/**
 * @description Profile Questionnaire Effects.
 * @exports
 * @class ProfileQuestionnaireEffects
 */
@Injectable()
export class ProfileQuestionnaireEffects {
  private readonly actions = inject(Actions);

  readonly onSwitchProfile_Logout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.switchProfile, AuthActions.logout),
        map(() => ProfileQuestionnaireActions.reset())
      );
    },
    { dispatch: true }
  );
}
